/**
 * Format how much time remains in a trial.
 * Examples: "in 12 days (March 1, 2026)", "tomorrow (February 16, 2026)", "today".
 */
export function formatTrialRemaining(trialEndsAt: number): string {
  const daysLeft = Math.max(
    0,
    Math.ceil((trialEndsAt - Date.now()) / (24 * 60 * 60 * 1000)),
  );
  const dateStr = new Date(trialEndsAt).toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  if (daysLeft <= 0) return "today";
  if (daysLeft === 1) return `tomorrow (${dateStr})`;
  return `in ${daysLeft} days (${dateStr})`;
}

/** Return whole days remaining in a trial (0 if expired). */
export function trialDaysLeft(trialEndsAt: number): number {
  return Math.max(
    0,
    Math.ceil((trialEndsAt - Date.now()) / (24 * 60 * 60 * 1000)),
  );
}

/**
 * Mirrors the backend `isLicensedSubscription` logic so the frontend can
 * gate actions before they hit the server.
 */
export function isOrgBillingActive(billingState: {
  status: string;
  trialEndsAt?: number;
  currentPeriodEnd?: number;
}): boolean {
  const now = Date.now();
  if (billingState.status === "trial") {
    return (
      typeof billingState.trialEndsAt === "number" &&
      billingState.trialEndsAt > now
    );
  }
  if (billingState.status === "active") {
    if (
      typeof billingState.currentPeriodEnd === "number" &&
      billingState.currentPeriodEnd <= now
    ) {
      return false;
    }
    return true;
  }
  return false;
}
